import { FileAccess } from 'monaco-editor/esm/vs/base/common/network.js';
function registerAssets(assets) {
    for (const [moduleId, url] of Object.entries(assets)) {
        FileAccess.registerAppResourcePathUrl(moduleId, url);
    }
}
export { registerAssets };
